import { render, staticRenderFns } from "./SummaryItemActionsDetails.vue?vue&type=template&id=6dfa7c04&"
import script from "./SummaryItemActionsDetails.vue?vue&type=script&lang=js&"
export * from "./SummaryItemActionsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports